import mapInit from './google/MapGoogle'

document.addEventListener('DOMContentLoaded', () => {
  mapInit()
})



// WEBPACK FOOTER //
// ./src/js/customs/_load.js